import React, { useEffect, useState } from "react";
import { useDataContext } from "./DataContext";
import FirebaseApp from "./Firecontact";
import { useParams, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const BlogDetail = () => {
  const { id } = useParams();
  const { getBlogById } = useDataContext();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const loadBlog = async () => {
      // Try to get from cache first
      const cachedBlog = await getBlogById(id);
      if (cachedBlog) {
        setBlog(cachedBlog);
        return;
      }

      // Fallback to direct fetch
      const db = FirebaseApp.firestore();
      db.collection("Blog")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            setBlog({ id: doc.id, ...doc.data() });
          } else {
            console.error("No such document!");
          }
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });
    };

    loadBlog();
  }, [id, getBlogById]);

  return (
    <div>
      <Header name="blog" />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 px-3">
            <div className="mb-4">
              <Link to="/blog" className="btn-back">
                <i className="fa fa-arrow-left me-2"></i> Back to Blog
              </Link>
            </div>
            {blog ? (
              <>
                <img src={blog.image} alt={blog.title} className="w-100 rounded-3 mb-4" />
                <p className="text-muted mb-2">Date: {new Date(blog.date).toLocaleDateString()}</p>
                <h2 className="mb-4">{blog.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: blog.content }} />
              </>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
